<template>
  <!-- 删除原有内容，只保留路由出口 -->
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>